export const TownsquareInteractionName = {
	// Users can view directories: https://tome.prod.atl-paas.net/capability/7bfb7463-655a-4475-b93a-790a7cefa6d4
	ProjectDirectoryViewed: 'projectDirectoryViewed',
	GoalDirectoryViewed: 'goalDirectoryViewed',
	TopicDirectoryViewed: 'topicDirectoryViewed',
	TopicPageViewed: 'topicPageViewed',
	ProjectAboutPageViewed: 'projectAboutPageViewed',
	ProjectUpdatesPageViewed: 'projectUpdatesPageViewed',
	ProjectLearningsPageViewed: 'projectLearningsPageViewed',
	ReadingModeViewed: 'readingModeViewed',
	TopicsHelpAndKnowledgePageViewed: 'topicsHelpAndKnowledgePageViewed',
	TopicsUpdatesPageViewed: 'topicsUpdatesPageViewed',
	PersonalSettingsPageViewed: 'personalSettingsPageViewed',
	WorkspaceSettingsPageViewed: 'workspaceSettingsPageViewed',
	FieldSettingsPageViewed: 'fieldSettingsPageViewed',
	TeamsSettingsPageViewed: 'teamsSettingsPageViewed',

	// No workspace
	NoWorkspaceTeamsDirectoryViewed: 'noWorkspaceTeamsDirectoryViewed',
	NoWorkspaceProjectsDirectoryViewed: 'noWorkspaceProjectsDirectoryViewed',
	NoWorkspaceGoalsDirectoryViewed: 'noWorkspaceGoalsDirectoryViewed',
	NoWorkspaceStatusUpdatesPageViewed: 'noWorkspaceStatusUpdatesPageViewed',

	// Share modals
	ProjectShareModalViewed: 'projectShareModalViewed',
	GoalShareModalViewed: 'goalShareModalViewed',

	TagUpdatesFeedViewed: 'tagUpdatesFeedViewed',
	TeamUpdatesFeedViewed: 'teamUpdatesFeedViewed',
	SavedViewUpdatesViewed: 'savedViewUpdatesViewed',
	ProjectUpdatesFeedViewed: 'projectUpdatesFeedViewed',
	GoalUpdatesFeedViewed: 'goalUpdatesFeedViewed',

	// Focus area sidebar
	// Dashboards: https://tome.prod.atl-paas.net/capability/d3b83c3d-5f28-4552-99b0-158d8fe7abc4
	FocusAreaUnlinked: 'townsquare-unlink-focus-area',
	FocusAreaSidebarViewed: 'focusAreaSidebarViewed', // pre-existing in townsquare

	// Goal page tabs
	// Dashboards: https://tome.prod.atl-paas.net/capability/ecec3a20-a466-432b-bb6f-9ebdcbf87560
	GoalAboutTabViewed: 'goal-about-tab-viewed',
	GoalUpdatesTabViewed: 'goal-updates-tab-viewed',
	GoalJiraTabViewed: 'goal-jira-tab-viewed',
	GoalJiraAlignTabViewed: 'goal-jiraAlign-tab-viewed',
	GoalProjectsTabViewed: 'goal-projects-tab-viewed',
	GoalLearningsTabViewed: 'goal-learnings-tab-viewed',
	GoalRisksTabViewed: 'goal-risks-tab-viewed',
	GoalDecisionsTabViewed: 'goal-decisions-tab-viewed',

	// Project page tabs
	// Dashboards: https://tome.prod.atl-paas.net/capability/ecec3a20-a466-432b-bb6f-9ebdcbf87560
	ProjectAboutTabViewed: 'project-about-tab-viewed',
	ProjectUpdatesTabViewed: 'project-updates-tab-viewed',
	ProjectLearningsTabViewed: 'project-learnings-tab-viewed',
	ProjectRisksTabViewed: 'project-risks-tab-viewed',
	ProjectDecisionsTabViewed: 'project-decisions-tab-viewed',

	// Comments
	// https://tome.prod.atl-paas.net/capability/8edd3fa6-02ff-424f-968f-33a618bf53b6
	GoalCommentsViewed: 'goalCommentsViewed',
	ProjectCommentsViewed: 'projectCommentsViewed',
	GoalUpdateCommentsViewed: 'goalUpdateCommentsViewed',
	ProjectUpdatesCommentsViewed: 'projectUpdateCommentsViewed',

	//Starred feed
	StarredFeedViewed: 'starredFeedViewed',

	// Home / page-level segmented regions
	// Dashboards: https://tome.prod.atl-paas.net/capability/d3b83c3d-5f28-4552-99b0-158d8fe7abc4
	WhereYouWorkViewed: 'whereYouWorkViewed', // pre-existing in townsquare
	YourAppsSectionViewed: 'yourAppsSectionViewed', // pre-existing in townsquare
	ThreadsViewed: 'threadsViewed', // pre-existing in townsquare

	// Metric targets
	CreateMetricTarget: 'townsquare-create-metric-target',

	ShareGoal: 'townsquare-share-goal',
	ShareProject: 'townsquare-share-project',

	// Project updates
	CreateNewProjectUpdate: 'townsquare-create-new-project-update',
	CreateNewProjectUpdateInline: 'townsquare-create-new-project-update-inline',

	// AI - Generate project update
	GenerateProjectUpdate: 'townsquare-generate-project-update',

	// Goal updates
	CreateNewGoalUpdate: 'townsquare-create-new-goal-update',

	// AI - Generate goal update
	GenerateGoalUpdate: 'townsquare-generate-goal-update',

	// Goal create
	GoalCreate: 'townsquare-goal-create',
	GoalMetricCreate: 'townsquare-goal-metric-create',
	SuccessMeasureCreate: 'townsquare-success-measure-create',

	// Project follow/unfollow
	FollowProject: 'townsquare-follow-project',
	UnfollowProject: 'townsquare-unfollow-project',

	// Goal follow/unfollow
	FollowGoal: 'townsquare-follow-goal',
	UnfollowGoal: 'townsquare-unfollow-goal',

	// Team follow/unfollow
	FollowTeam: 'townsquare-follow-team',
	UnfollowTeam: 'townsquare-unfollow-team',

	FollowTag: 'townsquare-follow-tag',

	// Tags
	AddTag: 'townsquare-add-tag',
	CreateTag: 'townsquare-create-tag',
	RemoveTag: 'townsquare-remove-tag',

	// Comments
	CreateComment: 'create-townsquare-comment',
	EditComment: 'edit-townsquare-comment',
	DeleteComment: 'delete-townsquare-comment',

	// Custom fields
	EditCustomFieldText: 'townsquare-edit-custom-field-text',
	EditCustomFieldNumber: 'townsquare-edit-custom-field-number',
	AddCustomFieldSelect: 'townsquare-add-custom-field-select',
	DeleteCustomFieldSelect: 'townsquare-delete-custom-field-select',
	AddCustomFieldUser: 'townsquare-add-custom-field-user',
	DeleteCustomFieldUser: 'townsquare-delete-custom-field-user',

	// AI - Set generation settings
	SetGenerationSettings: 'townsquare-set-generation-settings',
} as const;

export const TownsquareLoadHoldName = {
	// Custom fields
	EditCustomFieldTextLoading: 'townsquare-edit-custom-field-text-loading',
	EditCustomFieldNumberLoading: 'townsquare-edit-custom-field-number-loading',
	AddCustomFieldSelectLoading: 'townsquare-add-custom-field-select-loading',
	DeleteCustomFieldSelectLoading: 'townsquare-delete-custom-field-select-loading',
	AddCustomFieldUserLoading: 'townsquare-add-custom-field-user-loading',
	DeleteCustomFieldUserLoading: 'townsquare-delete-custom-field-user-loading',

	CreateCommentLoading: 'townsquare-create-comment-loading',
	CreateMetricTargetLoading: 'townsquare-create-metric-target-loading',
	CreateNewProjectUpdateLoading: 'townsquare-create-new-project-update-loading',
	CreateNewProjectUpdateInlineLoading: 'townsquare-create-new-project-update-inline-loading',
	CreateNewGoalUpdateLoading: 'townsquare-create-new-goal-update-loading',
	FollowProjectLoading: 'townsquare-project-follow-button-loading',
	FollowGoalLoading: 'townsquare-goal-follow-button-loading',
	FollowTeamLoading: 'townsquare-team-follow-loading',
	FollowTagLoading: 'townsquare-tag-follow-loading',
	AddTagLoading: 'townsquare-add-tag-loading',
	CreateTagLoading: 'townsquare-create-tag-loading',
	RemoveTagLoading: 'townsquare-remove-tag-loading',
	ProjectActionsFollowLoading: 'townsquare-project-actions-follow-loading',
	ShareGoalLoading: 'townsquare-share-goal-loading',
	ShareProjectLoading: 'townsquare-share-project-loading',

	// AI - Set generation settings
	SetGenerationSettingsLoading: 'townsquare-set-generation-settings-loading',
} as const;

export const GoalTabSegmentName: {
	readonly about: 'goal-about-tab-viewed';
	readonly updates: 'goal-updates-tab-viewed';
	readonly jira: 'goal-jira-tab-viewed';
	readonly jiraAlign: 'goal-jiraAlign-tab-viewed';
	readonly projects: 'goal-projects-tab-viewed';
	readonly learnings: 'goal-learnings-tab-viewed';
	readonly risks: 'goal-risks-tab-viewed';
	readonly decisions: 'goal-decisions-tab-viewed';
} = {
	about: TownsquareInteractionName.GoalAboutTabViewed,
	updates: TownsquareInteractionName.GoalUpdatesTabViewed,
	jira: TownsquareInteractionName.GoalJiraTabViewed,
	jiraAlign: TownsquareInteractionName.GoalJiraAlignTabViewed,
	projects: TownsquareInteractionName.GoalProjectsTabViewed,
	learnings: TownsquareInteractionName.GoalLearningsTabViewed,
	risks: TownsquareInteractionName.GoalRisksTabViewed,
	decisions: TownsquareInteractionName.GoalDecisionsTabViewed,
} as const;

export type GoalTabName = keyof typeof GoalTabSegmentName;

export const isGoalTabName = (tabName: string): tabName is GoalTabName =>
	tabName in GoalTabSegmentName;

export const ProjectTabSegmentName: {
	readonly about: 'project-about-tab-viewed';
	readonly updates: 'project-updates-tab-viewed';
	readonly learnings: 'project-learnings-tab-viewed';
	readonly risks: 'project-risks-tab-viewed';
	readonly decisions: 'project-decisions-tab-viewed';
} = {
	about: TownsquareInteractionName.ProjectAboutTabViewed,
	updates: TownsquareInteractionName.ProjectUpdatesTabViewed,
	learnings: TownsquareInteractionName.ProjectLearningsTabViewed,
	risks: TownsquareInteractionName.ProjectRisksTabViewed,
	decisions: TownsquareInteractionName.ProjectDecisionsTabViewed,
} as const;

export type ProjectTabName = keyof typeof ProjectTabSegmentName;

export const isProjectTabName = (tabName: string): tabName is ProjectTabName =>
	tabName in ProjectTabSegmentName;

export const CommentsSegmentName: {
	readonly goal: 'goalCommentsViewed';
	readonly 'goal-update': 'goalUpdateCommentsViewed';
	readonly project: 'projectCommentsViewed';
	readonly 'project-update': 'projectUpdateCommentsViewed';
} = {
	goal: TownsquareInteractionName.GoalCommentsViewed,
	'goal-update': TownsquareInteractionName.GoalUpdateCommentsViewed,
	project: TownsquareInteractionName.ProjectCommentsViewed,
	'project-update': TownsquareInteractionName.ProjectUpdatesCommentsViewed,
} as const;
